export const MEASURE_TYPE = {
  QTY: 'qty',
  KGRAM: 'kg',
  GRAM: 'g',
};
